import f from "../funcs";
import Events from "./Events";
import $ from "jquery";
import "css!classes/Loader";


/* test for version  */

let index = 0;

// хранилище активных загрузок
// на каждый loader.start оно пополняется
// P.S. смотри LoaderClone
let LoaderKeys = f.CreateClass("LoaderKeys", {});
LoaderKeys.prototype.init = function() {
    this.index = index++;
    this._data = {};
};

LoaderKeys.prototype.toString = function() {
    return "[" + Object.keys(this._data).toString() + "]";
};

LoaderKeys.prototype.create = function() {
    return "lk-" + index++;
};

LoaderKeys.prototype.add = function(key) {
    this._data[key] = true;
};

LoaderKeys.prototype.remove = function(key) {
    delete this._data[key];
};

LoaderKeys.prototype.getLength = function() {
    return Object.keys(this._data).length;
};

LoaderKeys.prototype.isEmpty = function() {
    return this.getLength() === 0;
};

let Loader = f.CreateClass("Loader", {
    delay: 300
}, Events);

Loader.prototype.init = function(params) {
    params = params || {};

    if ( !params.width ) {
        params.width = 90;
    }

    this.keys = new LoaderKeys();
    this.key = this.keys.create();
    if ( params.customInit ) {
        params.customInit(this, params);
    } else {
        this.initBox(params);
        this.$el = $([
            "<div class='js-loader'>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "<div class='js-loader-helper'></div>",
            "</div>"
        ].join(""));
        this.el = this.$el[0];
        this.$el.appendTo(this.$box);
    }
};

Loader.prototype.initBox = f.initBox;

Loader.prototype.start = function(key) {
    if ( this.keys.isEmpty() ) {
        this.startAnimation();
    }

    key = key || this.key;
    this.keys.add(key);
};

Loader.prototype.startAnimation = function() {
    clearTimeout(this.timer);
    // this.timer = setTimeout(function() {
    // 	this.$box.addClass("loading");
    // }.bind(this), this.delay);
    this.$box.addClass("loading");
};


Loader.prototype.stop = function(key) {
    key = key || this.key;
    this.keys.remove(key);

    if ( this.keys.isEmpty() ) {
        this.stopAnimation();
    }
};

Loader.prototype.stopAnimation = function() {
    clearTimeout(this.timer);
    this.timer = setTimeout(function() {
        this.$box.removeClass("loading");
    }.bind(this), 0);
};

// когда нужен невидимый лоадер используем fake
Loader.fake = function() {
    return new Loader({ box: document.createElement("div") });
};

// создаем клон,
// который потом будет вызвать start, stop оригинала
// если  не делать клона, а использовать оригинал, то в тех классах,
// которые использовуют loader,
// придеться следить за кол-вом обращений к loader.start,
// а именно - будет баг с повторным вызов loader.start,
// без промежуточного loader.stop.
// Так же loader.start (в обычном режиме) начинает анимацию сначала
Loader.prototype.clone = function() {
    return new LoaderClone(this);
};

const LoaderClone = f.CreateClass("LoaderClone");
LoaderClone.prototype.init = function(loader) {
    this.key = loader.keys.create();
    loader.keys.add(this.key);
    this.loader = loader;
};

LoaderClone.prototype.start = function() {
    this.loader.start(this.key);
};

LoaderClone.prototype.stop = function() {
    this.loader.stop(this.key);
};
LoaderClone.prototype.clone = function() {
    return this.loader.clone();
};

export default Loader;
